import React from 'react';
import api from 'api';
import { connect } from 'react-redux';
import moment from 'moment';
import { Observable } from 'rxjs';
import { push } from 'react-router-redux';
import FgCompanyLogo from '../components/clients/FgCompanyLogo';
import KeyBinder from '../utils/KeyBinder';
import EmployeeImage from './clients/EmployeeImage';

var initialState = {
    isOpen: false,
    hasSearched: false,
    searchText: '',
    matchingEntities: [],
    isLoadingEntitySearch: false,
    currentIndex: 0
};


@connect(
    state => ({
        recentlyViewedClients: state.entitySearch.recentlyViewedClients,
        staff: state.users.users
    }),
    { push }
)
export default class NavbarEntitySearch extends React.Component {

    constructor(props) {
        super(props);
        this.state = initialState;
        this.renderSearchItem = this.renderSearchItem.bind(this);
    }

    componentDidMount(){
        this.keyBinder = new KeyBinder({
            escapePressed: this.onEscape.bind(this),
            altFPressed: this.onAltF.bind(this),
            bodyClick: this.onBodyClick.bind(this)
        });

        var keyup$ = Observable.fromEvent(this.searchInput, 'keyup');

        var searchKeyUps$ = keyup$
            .map(e => e.target.value)
            .filter(text => text.length > 2)
            .debounceTime(400)
            .distinctUntilChanged() // Only if the value has changed
            .do(() => {
                this.setState({isLoadingEntitySearch: true});
            });

        var searches$ = searchKeyUps$
            .switchMap(searchText => 
                Observable.from(
                    api.post('entity_search', {searchText})
                )
            );

        searches$.subscribe(searchResponse => {
            var matchingEntities = searchResponse.value;

            this.setState({
                matchingEntities,
                hasSearched: true,
                isLoadingEntitySearch: false
            });
        });
    }

    componentWillUnmount(){
        this.keyBinder.destroy();
    }

    onSearch(searchText){
        this.setState({isLoadingEntitySearch: true});

        api.post('entity_search', {searchText: searchText})
            .then(searchResponse => {
                var matchingEntities = searchResponse.value;

                this.setState({
                    matchingEntities,
                    hasSearched: true,
                    isLoadingEntitySearch: false
                });
            });
    }
    searchKeyDown(e) {
        var up = 38;
        var down = 40;
        var enter = 13;
        if (e.keyCode == up){
            return this.moveUp();
        }
        if (e.keyCode == down){
            return this.moveDown();
        }
        if (e.keyCode == enter){
            e.preventDefault();
            var client = this.state.searchText.length ? this.state.matchingEntities[this.state.currentIndex] : this.props.recentlyViewedClients[this.state.currentIndex];
            this.transitionToClient(client.clientId);
            
        }
    }

    moveDown(){
        var endIndex = this.state.searchText.length ? this.state.matchingEntities.length - 1 : this.props.recentlyViewedClients.length - 1;
        var newIndex = Math.min(this.state.currentIndex + 1, endIndex);

        this.setState({
            currentIndex : newIndex
        });
    }
    moveUp(){
        var newIndex = Math.max(this.state.currentIndex - 1, 0);
        this.setState({
            currentIndex : newIndex
        });
    }

    scheduleSearch(e) {
        clearTimeout(this.updateTimer);
        this.updateTimer = setTimeout(() => {
            this.onSearch(this.state.searchText);
        }, 500);
    }

    transitionToClient(clientId, e) {
        this.searchInput.blur();

        this.setState({...initialState}, () => {
            this.props.push(`/clients/${clientId}`);
        });
    }

    onEscape(){
        this.setState(Object.assign(initialState, {}));
    }

    onAltF(){
        this.setState({isOpen: true});
        this.searchInput.focus();
    }

    onBodyClick(e){
        var clickedInsideNavbarSearch = e.detail.classList.contains('searchEl') || e.detail.classList.contains('form-control');
        if (this.state.isOpen && ! clickedInsideNavbarSearch) {
            this.setState(Object.assign(initialState, {}));
        }
    }

    handleFocus(e) {
        this.setState({isOpen: true});
    }

    handleChange(e) {
        this.setState({searchText: e.target.value});
    }

    renderSearchItem(entity, i) {
        var entityPreview = () => {
            switch (entity.entityType) {
                case 'contact':
                    return (<i className="fa fa-user entity-preview-icon"></i>);
                case 'employee':
                    return (<EmployeeImage guid={entity.guid} />);
                case 'contactEmail':
                    // account for email icon being larger with padding
                    return (<i style={{paddingRight: '20px'}} className="fa fa-envelope entity-preview-icon"></i>);
                case 'contactNumber':
                    return (<i className="fa fa-phone entity-preview-icon"></i>);
                default:
                    // entity.entityType == 'company
                    return (<FgCompanyLogo fergusId={entity.fergusId} />);
            }
        };

        var entityDetails = () => {
            switch (entity.entityType) {
                case 'employee':
                    return (
                        <div>
                            <h4 className="media-heading">{entity.entityName.limit(30)}</h4>
                            <p>{entity.email}</p>
                        </div>
                    );
                case 'contact':
                    return (
                        <div>
                            <h4 className="media-heading">{entity.entityName.limit(30)}</h4>
                            <p>{entity.contactTitle}</p>
                        </div>
                    );
                case 'contactEmail':
                    return (
                        <div>
                            <h4 className="media-heading">{entity.entityName.limit(30)}: {entity.contactTitle}</h4>
                            <p>{entity.contactEmail}</p>
                            <p></p>
                        </div>
                    );
                case 'contactNumber':
                    return (
                        <div>
                            <h4 className="media-heading">{entity.entityName.limit(30)}: {entity.contactTitle}</h4>
                            <p>{entity.contactNumber}</p>
                        </div>
                    );
                default:
                    var getLabel = () => {
                        var status = entity.status;

                        if(status == 'Dud') {
                            return <span className="label label-danger pull-right">Dud</span>
                        }

                        if(entity.isPaying) {
                            return <span className="label label-success pull-right">Paying</span>
                        }

                        if (entity.companyOnTrial){
                            return <span className="label label-primary pull-right">On Trial</span>
                        }
                        if (entity.trialExpired){
                            return <span className="label label-danger pull-right">Trial Expired</span>
                        }

                        return null;
                    };

                    var getRegisteredAt = () => {
                        var date = entity.signedUpAt ? moment(entity.signedUpAt).format('MMM D, YYYY') : moment(entity.createdAt).format('MMM D, YYYY');
                        return <span className="registered-preview"><i className="fa fa-user"></i> {date}</span>
                    };

                    var assignedStaffMember = this.props.staff ? this.props.staff.find(u => u.id == entity.assignedUserIds) : null;
                    var staffMemberPreview = ! assignedStaffMember ? null : (
                        <span className="assigned-preview"><i className="fa fa-user"></i> {` ${assignedStaffMember.firstName} ${assignedStaffMember.lastName} `}</span>
                    );

                    return (
                        <div>
                            <h4 className="media-heading">
                                {getLabel()}
                                {entity.publicId &&
                                    <span className="clientId">#{entity.publicId} </span>
                                }                                
                                <p>
                                    {entity.entityName.limit(50)}
                                </p>
                            </h4>
                            <div className="previews-wrapper">
                                {staffMemberPreview}
                                {entity.score &&
                                    <span className="score-preview"><i className="fa fa-trophy"></i> {entity.score}</span>
                                }
                                {getRegisteredAt()}
                            </div>
                        </div>
                    );
            }
        };

        return (
            <div onClick={this.transitionToClient.bind(this, entity.clientId)} className={this.state.currentIndex == i ? 'item-wrapper media is-selected-result' : 'item-wrapper media'} key={i}>
                    <div className="media-left">
                        <div className="media-object">
                            {entityPreview()}
                        </div>
                    </div>
                    <div className="media-body">
                        {entityDetails()}
                    </div>
            </div>
        );
    }

    render() {
        var style = !isMobile && !this.state.isOpen ? {width: 170} : {};
        var searchInput = (
            <input type="search"
                style={style}
                ref={el => this.searchInput = el}
                className="form-control"
                onChange={this.handleChange.bind(this)}
                onKeyDown={this.searchKeyDown.bind(this)}
                value={this.state.searchText}
                onFocus={this.handleFocus.bind(this)}
                placeholder="Search everything..."/>
        );

        var {isMobile} = this.props;

        return (
            <div id="entity-search" className={this.props.isMobile ? "mobile-entity-search" : ""}>
                <form className={this.props.isMobile ? "" : "navbar-form navbar-left"}>
                    {!isMobile && this.state.searchText.length > 0 && this.state.isLoadingEntitySearch &&
                    <i className="fa fa-spinner fa-pulse"></i>
                    }
                    {!isMobile && ! this.state.isLoadingEntitySearch &&
                    <i className="fa fa-search"></i>
                    }
                    {!isMobile && searchInput}

                    {!isMobile && !this.state.isOpen &&
                        <span style={{color: '#bcbfc1', fontSize: 10}}>ALT+F</span>    
                    }

                    {isMobile &&
                        <div id="mobile-search-input-wrapper">
                            {searchInput}
                        </div>
                    }
                    <div className={this.state.searchText.length <= 2 && this.state.isOpen ? "dropdown open" : "dropdown"}>
                        <div className="dropdown-menu">
                            <div className="dropdown-menu-header">
                                <strong><i className="fa fa-clock-o"></i> Recently viewed: </strong>
                            </div>
                            {! this.props.recentlyViewedClients.length &&
                            <div className="not-viewed-clients">
                                <p>You haven‘t viewed any clients</p>
                            </div>
                            }
                            <ul className="media-list">
                            {this.props.recentlyViewedClients.map(this.renderSearchItem)}
                            </ul>
                        </div>
                    </div>
                    <div className={this.state.searchText.length > 2 && this.state.isOpen ? "dropdown open" : "dropdown"}>
                        <ul className="dropdown-menu">
                            <li className="dropdown-menu-header">
                                <strong><i className="fa fa-star"></i> Top results: </strong>
                            </li>
                            {! this.state.isLoadingEntitySearch && ! this.state.matchingEntities.length &&
                                <li className="loading-or-no-results">
                                    {this.state.hasSearched && <p>No results found</p>}
                                    {! this.state.hasSearched && <p>Loading...</p>}
                                </li>
                            }
                            {this.state.matchingEntities.map(this.renderSearchItem)}
                        </ul>
                    </div>
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/NavbarEntitySearch.js